<div [formGroup]="formGroup">
  <input [type]="field.appearance || 'text'" [formControlName]="field.name" id="{{field.name}}" [maxLength]="maxLength" />
</div>
